import { Injectable } from '@angular/core';
import { Utility } from '../../_service/utility';

@Injectable()
export class BulletStyleService {

  constructor(_utility:Utility)
  {
    if(_utility.isIphoneDevice())
    {
      this.fontList.forEach(p=>p["font-family"] = "-apple-system, " +p["font-family"]); ///apply 字体调整
    }
  }
  fontList: Array<any> =
    [
      {
        name: '楷体',
        value: 1,
        'font-family': 'KaiTi,楷体'
      },
      {
        name: '黑体',
        value: 2,
        'font-family': 'SimHei,黑体'
      },
      {
        name: '幼圆',
        value: 3,
        'font-family': 'YouYuan,幼圆'
      },
      {
        name: '雅黑',
        value: 4,
        'font-family': '"Microsoft YaHei",微软雅黑'
      },
      {
        name: '新宋',
        value: 5,
        'font-family': 'SimSun,新宋体',
        isDefault:true
      },
    ];

  colorList = [
    {
      name: '白色',
      reverse:true,
      value: 0,
      color: '#ffffff',
      vipFunction: false,
      'text-shadow': 'rgb(0, 0, 0) 0px 0px 2px, rgb(0, 0, 0) 0px 0px 2px, rgb(0, 0, 0) 0px 0px 2px',
    },
    {
      name: '紫色',
      value: 1,
      color: '#dda7e5',
      vipFunction: true,
    },
    {
      name: '绿色',
      value: 2,
      color: '#3bc529',
      vipFunction: true,
    },
    {
      name: '蓝色',
      value: 3,
      color: '#00bacf',
      vipFunction: true,
    },
    {
      name: '黄色',
      value: 4,
      color: '#fffc00',
      vipFunction: true,
    },
    {
      name: '红色',
      value: 5,
      color: '#fe0000',
      vipFunction: true,
    },
    {
      name: '橙色',
      value: 6,
      color: '#ff7200',
      vipFunction: true,
    },
    {
      name: '黑色',
      value: 7,
      color: '#000000',
      vipFunction: true,
      'text-shadow': '-1px 0 white, 0 1px white, 1px 0 white, 0 -1px white',
    }
  ];
  styleList = [
    // {
    //   name: '超大',
    //   value: 1,
    //   'font-size': '18px'
    // },
    // {
    //   name: '发光',
    //   value: 2,
    // 'text-shadow': '1px 1px 2px #eaeaea'
    // },
    // {
    //   name: '外框',
    //   value: 3,
    //   'border': '1px solid red',
    //   'padding': '0 0.5em'
    // },
    // {
    //   name: '默认',
    //   value: 0
    // }
  ];

  public getStyle(option: any, currentStyle = {}) {
   // const fontFamily = this.fontList.filter(p => p.value === Number(option['font-family']))[0];
    const color = option.color ? this.colorList.filter(p => p.color === option.color)[0] : this.colorList[0];
   // const style = this.styleList.filter(p => p.value === option.style)[0];
   // const opacity = { opacity: option.opacity / 100 };
    const obj = Object.assign(currentStyle,  color );
    delete obj.name;
    delete obj.value;
    return obj;
  }
}

export class StyleOption {
  //public font;
  public color;
  //public opacity;
  //public style;
  //public 'font-family';
}
